import React, { useState } from 'react';
import { getCertificationInfo } from '../../../constants/certificationTypes';

const STORLEKAR = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 sm:w-12 sm:h-12 text-xs sm:text-sm',
  lg: 'w-12 h-12 text-sm'
};

/**
 * Märket för en behörighetstyp: utfärdarens logotyp när filen finns i
 * public/images/certifications, annars en färgad ruta med förkortningen.
 *
 * Logotypsökvägarna har funnits i certificationTypes sedan start, men filerna
 * lades aldrig in — vyerna ritade därför bara rutan. Nu räcker det att lägga
 * in filen så syns den överallt, och en saknad fil faller tillbaka tyst.
 */
const CertifieringsMarke = ({ type, size = 'md' }) => {
  const info = getCertificationInfo(type);
  const [logoSaknas, setLogoSaknas] = useState(false);
  const klass = STORLEKAR[size] || STORLEKAR.md;

  if (info.logo && !logoSaknas) {
    return (
      <div className={`${klass} rounded-lg bg-white border border-gray-200 flex items-center justify-center flex-shrink-0 p-1`}>
        <img
          src={info.logo}
          alt={info.name}
          className="max-w-full max-h-full object-contain"
          onError={() => setLogoSaknas(true)}
        />
      </div>
    );
  }

  return (
    <div
      className={`${klass} rounded-lg flex items-center justify-center text-white font-bold flex-shrink-0`}
      style={{ backgroundColor: info.color }}
    >
      {info.shortName?.substring(0, 3) || '?'}
    </div>
  );
};

export default CertifieringsMarke;
